module.exports = __webpack_public_path__ + "assets/img/START_BLOCKCHAIN_EVENT_PLUGIN.86abfe6b.svg";